import React, { ReactNode } from "react";
import useScrollToTopHook from "utils/scrool/useScroolHook";
import { Footer } from "components/footer/Footer";
import { Header } from "components/header/Header";
import { WhatsAppIcon } from "components/icons/WhatsAppIcon";

interface RouterContainerProps {
  children: ReactNode;
}

export const RouterContainer = ({ children }: RouterContainerProps) => {
  return (
    <main>
      {useScrollToTopHook()}
      <Header />
      {children}
      <Footer />
      <WhatsAppIcon />
    </main>
  );
};
